import "./style.scss";
import * as React from "react";
import { Form, Button } from "antd";

import ReportStructure from "./ReportStructure";
import ReportFormat from "./ReportFormat";

class StageOne extends React.Component<any, any> {
  handleSubmit(e: EventTarget) {
    this.props.form.validateFieldsAndScroll((err: any) => {
      // Custom validation for metrics and dimensions
      // as we don't use standard input elements
      if (
        !err &&
        this.props.structure.dimensions.selected.length > 0 &&
        this.props.structure.metrics.selected.length > 0
      ) {
        this.props.next();
      } else {
        console.warn("Stage one not valid!");
      }
    });
  }

  render() {
    return (
      <div className="stage-one">
        <ReportFormat
          editName={this.props.editName}
          editFilename={this.props.editFilename}
          editDescription={this.props.editDescription}
          editDelimiter={this.props.editDelimiter}
          editDuration={this.props.editDuration}
          toggleCompressed={this.props.toggleCompressed}
          form={this.props.form}
          {...this.props.format}
        />

        <ReportStructure
          addDimension={this.props.addDimension}
          removeDimension={this.props.removeDimension}
          reorderDimension={this.props.reorderDimension}
          addMetric={this.props.addMetric}
          removeMetric={this.props.removeMetric}
          reorderMetric={this.props.reorderMetric}
          form={this.props.form}
          {...this.props.structure}
        />

        <Button
          type="primary"
          className="next"
          onClick={this.handleSubmit.bind(this)}
        >
          Next
        </Button>
      </div>
    );
  }
}

export default Form.create()(StageOne);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/component.tsx